import { useState, useEffect, useContext, memo } from 'react';
import styled from 'styled-components';
import { Col, Row, FormSelect } from 'react-bootstrap';
import PropTypes from 'prop-types';
import RestaurantContext from '../../Context/RestaurantContext';

const Wrapper = styled.div``;

const Label = styled.span`
  font-size: 14px;
  letter-spacing: 0.62px;
  font-weight: 400;
`;

const StyledSelector = styled(FormSelect)`
  border: 1px solid rgba(133, 133, 133, 0.15);
  font-size: 14px;
  cursor: pointer;
`;

const DesiredDeliveryTimeSelectorComponent = ({
  isPickUp,
  pickUpTimes,
  deliveryTimes,
  selectedPickUpTime,
  selectedDeliveryTime,
  onSelectionChanged,
  ...rest
}) => {
  const times = isPickUp ? (pickUpTimes || []) : (deliveryTimes || []);
  const value = isPickUp ? selectedPickUpTime : selectedDeliveryTime;

  return (
    <Wrapper>
      <Row style={{ alignItems: 'center' }}>
        <Col xs={6}>
          <Label>Gewünschte {isPickUp ? 'Abholzeit' : 'Lieferzeit'}</Label>
        </Col>
        <Col xs={6}>
          <StyledSelector
            type="select"
            value={value || ''}
            onChange={e => onSelectionChanged(e.target.value)}
            {...rest}
          >
            {times.map(({ value, label }) => (
              <option key={`${value}-${label}`} value={value}>
                {label}
              </option>
            ))}
          </StyledSelector>
        </Col>
      </Row>
    </Wrapper>
  );
};

DesiredDeliveryTimeSelectorComponent.propTypes = {
  isPickUp:                PropTypes.bool.isRequired,
  pickUpTimes:             PropTypes.array,
  deliveryTimes:           PropTypes.array,
  selectedPickUpTime:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedDeliveryTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectionChanged:      PropTypes.func,
};

export default memo(DesiredDeliveryTimeSelectorComponent);
